import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';

import { Document } from 'types';
import { getDocumentsByIds } from 'modules/documents/api/getDocumentsByIds';
import { getDocument } from 'modules/documents/redux/documentActions';

type UseGetDocumentsProps = {
  documentIds: string[];
};

export const useGetDocuments = ({ documentIds }: UseGetDocumentsProps) => {
  const [documents, setDocuments] = useState<Document[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchDocuments = useCallback(async () => {
    try {
      if (documentIds.length > 0) {
        setIsLoading(true);

        const documents =
          documentIds.length === 1
            ? await store.dispatch(getDocument(documentIds[0]))
            : await store.dispatch(getDocumentsByIds({ documentIds }));

        setDocuments(documents);
      }
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [documentIds]);

  useEffect(() => {
    fetchDocuments();
  }, [fetchDocuments]);

  return {
    data: { documents },
    isLoading,
    isError,
    actions: { setIsLoading },
  };
};
